@if (formGroup) {
  <form [formGroup]="formGroup" (ngSubmit)="save()">
    <dialog class="bm-modal" open (document:keydown.escape)="closeModal.emit()">
      <div class="bm-modal-box max-h-[80vh] overflow-y-auto">
        <h4 class="text-lg font-bold">Priorität bearbeiten</h4>
        <fieldset class="bm-fieldset px-0">
          <label class="bm-fieldset-label">Name*</label>
          <input class="bm-input" formControlName="name" />

          <label class="bm-fieldset-label">Farbe*</label>
          <input type="color" class="bm-input" formControlName="color" />

          <label class="bm-fieldset-label">SLA-Typ</label>
          <select class="bm-select" formControlName="sla_type">
            <option value="NO">Kein SLA</option>
          </select>

          <label class="bm-fieldset-label">Tage</label>
          <input class="bm-input" type="number" min="0" matInput formControlName="days" />

          <label class="bm-fieldset-label">Stunden</label>
          <input class="bm-input" type="number" min="0" matInput formControlName="hours" />

          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="material_return" />
            Materialrücksendung
          </label>

          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="material_shipping" />
            Materialversand
          </label>

          <label class="bm-fieldset-label">
            <input type="checkbox" class="bm-checkbox" formControlName="staging" />
            Staging
          </label>

          <!-- Flexible Wochenaufträge: in der App „Bitte in dieser KW erledigen“ (see bentomax/hawk#617) -->
          <label class="bm-fieldset-label" title="Einsätze erscheinen in der App nicht im Tagesplan, sondern als Wochenaufgabe und werden bis zur Frist wöchentlich verschoben">
            <input type="checkbox" class="bm-checkbox" formControlName="flexible_week" />
            Flexibler Wochenauftrag
          </label>
        </fieldset>

        <div class="bm-modal-action">
          <button class="bm-btn bm-btn-secondary" type="button" (click)="closeModal.emit()">Abbrechen</button>
          <button class="bm-btn bm-btn-primary" type="submit" [disabled]="!formGroup.valid">Speichern</button>
        </div>
      </div>
    </dialog>
  </form>
}
